import { render, staticRenderFns } from "./Timeshifts.vue?vue&type=template&id=5af1591e&v-on-clickaway=cancel&"
import script from "./Timeshifts.vue?vue&type=script&lang=ts&"
export * from "./Timeshifts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports